import {__flags_endpoints} from "@components/flags/endpoints/__flags_endpoints.ts";
import {IFlag} from "@models/shared/IFlag.ts";
import {IGetFlagsFilter} from "@localization/siteMap/endpoints/flags/filters/IGetFlagsFilter.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

export function useFlags() {
    const {Get} = useApi()

    const createFlag = async (body: Pick<IFlag, 'nome' | 'tipo' | 'ordem' | 'descricao'>) => {
        return await Get(__flags_endpoints.CreateFlag(body));
    }

    const getFlags = async ({filters, pagination}: {
        filters?: IGetFlagsFilter,
        pagination?: IPagination,
        ignoreCache?: boolean
    }) => {
        return await Get(__flags_endpoints.GetFlags({filters, pagination}));
    }

    return {createFlag, getFlags}
}